module.exports = __webpack_public_path__ + "img/visa.05772192.svg";